/**
 * @class ProductCrossSellSlider
 * @classdesc This component fetches content for the cross-sell feature
 *
 * @extends Core.Component
 */

export default class ProductCrossSellSlider extends Core.Component {
  constructor(el, context) {
    super(el, context);
  }

  onMount() {
    let sectionId;

    const cart = this.closest('main-cart');

    if (cart) {
      sectionId = cart.sectionId;
    }

    const productId = this.data.product_id;

    if (sectionId && productId) {
      this
        .fetchRecommendations(sectionId, productId);
    }
  }

  /**
   * Fetches section content via the Shopify recommendations endpoint
   * @param {string} sectionId - the ID of the section to fetch
   * @param {string} productId - the ID of the product on which to base recommendations
   */
  fetchRecommendations(sectionId, productId) {
    const url = `${this.data.recommendations_route}?section_id=${sectionId}&product_id=${productId}&limit=4`;
    return fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        this.el.querySelector('[data-cross-sell-content]').innerHTML = html.querySelector('[data-cross-sell-content]').innerHTML;
      });
  }
}
